module.exports = __webpack_public_path__ + "media/images/titleSponsor-8d084b1ae428109258be7fbe42eb5de5.png";